import { RootState } from '../../index';

export const countriesSelector = (state: RootState) => state.country.countries;
